import PropTypes from "prop-types";
import React, { useContext, useState } from "react";
import ClickAwayListener from "react-click-away-listener";
import PiggyContext from "../../context/piggy/PiggyContext";
import UserContext from "../../context/user/UserContext";
import { delRecord } from "../../firebase/docs";

function DeleteRecord(props) {
  const userContext = useContext(UserContext);
  const piggyContext = useContext(PiggyContext);

  const [active, setActive] = useState(false);

  const DeleteIcon = () => (
    <svg
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
    >
      <path d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z" />
    </svg>
  );

  const handleClickAway = () => {
    if (active) setActive(false);
  };
  const handleDeleteRecord = async () => {
    await delRecord(props.id, userContext.user.uid);
    const tempRows = piggyContext.rows;
    const index = await tempRows.findIndex((elem) => elem.id === props.id);

    piggyContext.setRows(
      tempRows.slice(0, index).concat(tempRows.slice(index + 1))
    );

    setActive(false);
  };

  return (
    <>
      <button
        onClick={() => setActive(true)}
        title="Delete Details"
        className="h-3 w-3 rounded-full text-gray-400 hover:scale-125 hover:text-red-500"
      >
        <DeleteIcon />
      </button>

      {active && (
        <div className="h-modal fixed top-0 right-0 left-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden bg-black bg-opacity-20 md:inset-0 md:h-full">
          <div className="relative h-full w-full max-w-md p-4 md:h-auto">
            <ClickAwayListener onClickAway={handleClickAway}>
              <div className="relative rounded-lg bg-white shadow-md ">
                {/* Close Btn */}
                <button className="absolute top-3 right-2.5 ml-auto inline-flex items-center rounded-lg bg-transparent p-1.5 text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900 ">
                  <svg
                    aria-hidden="true"
                    className="h-5 w-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </button>

                <div className="p-6 text-center">
                  {/* Exclamation Symbol */}
                  <svg
                    aria-hidden="true"
                    className="mx-auto mb-4 h-14 w-14 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                  </svg>

                  {/* Conformatory Text */}
                  <h3 className="mb-5 text-lg font-normal text-gray-500 ">
                    Are you sure you want to delete this record?
                  </h3>

                  {/* Conform Btn */}
                  <button
                    onClick={handleDeleteRecord}
                    className="mr-2 inline-flex items-center rounded-lg bg-red-600 px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-red-800 focus:outline-none focus:ring-4 focus:ring-red-300 "
                  >
                    Yes, I'm sure
                  </button>

                  {/* Cancel Btn */}
                  <button
                    onClick={() => setActive(false)}
                    className="rounded-lg border border-gray-200 bg-white px-5 py-2.5 text-sm font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-900 focus:z-10 focus:outline-none focus:ring-4 focus:ring-gray-200 "
                  >
                    No, cancel
                  </button>
                </div>
              </div>
            </ClickAwayListener>
          </div>
        </div>
      )}
    </>
  );
}

export default DeleteRecord;

DeleteRecord.propTypes = {
  id: PropTypes.string.isRequired,
};
